import * as React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

interface Props extends React.HTMLProps<HTMLInputElement> {
  firstLabelClassName?: string
  firstLabelText: string
  secondLabelClassName?: string
  secondLabelText: string
  wrapperClassName?: string
}

export const TwoColumnLabelRadio: React.FC<Props> = ({
  className,
  firstLabelClassName,
  firstLabelText,
  secondLabelClassName,
  secondLabelText,
  wrapperClassName,
  ...rest
}) => {
  const inputClassName = classnames(styles.input, className)

  return (
    <label className={classnames(styles.labelWrapper, wrapperClassName)}>
      <input className={inputClassName} type="radio" {...rest} />

      <div className={styles.labelColumn1}>
        <span className={firstLabelClassName}>{firstLabelText}</span>
      </div>

      <div className={styles.labelColumn2}>
        <span className={secondLabelClassName}>{secondLabelText}</span>
      </div>
    </label>
  )
}
